import React, { createContext, useContext, useState, useEffect } from 'react';
import apiService from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 토큰 저장소 관리
  const getToken = () => localStorage.getItem('auth_token');
  const setToken = (token) => localStorage.setItem('auth_token', token);
  const removeToken = () => localStorage.removeItem('auth_token');

  // 로그인 함수
  const login = async (username, password) => {
    try {
      const response = await apiService.login({ username, password });
      const { access_token } = response.data;
      
      setToken(access_token);
      setIsAuthenticated(true);
      
      // 사용자 정보 가져오기
      const userResponse = await apiService.getCurrentUser();
      setUser(userResponse.data);
      
      return { success: true };
    } catch (error) {
      
      return { 
        success: false, 
        error: error.response?.data?.detail || '로그인에 실패했습니다.' 
      };
    }
  };

  // 로그아웃 함수
  const logout = async () => {
    try {
      await apiService.logout();
    } catch (error) {
      
    } finally {
      removeToken();
      setIsAuthenticated(false);
      setUser(null);
    }
  };

  // 토큰 검증 및 사용자 정보 로드
  const checkAuth = async () => {
    const token = getToken();
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const userResponse = await apiService.getCurrentUser();
      setUser(userResponse.data);
      setIsAuthenticated(true);
    } catch (error) {
      removeToken();
      setIsAuthenticated(false);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  // 컴포넌트 마운트 시 인증 상태 확인
  useEffect(() => {
    checkAuth();
  }, []);

  const value = {
    isAuthenticated,
    user,
    loading,
    login,
    logout,
    getToken
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}; 